import {
  AUTHORIZED_ROUTES_LOCAL_STORAGE,
  PERMISSION_LOCAL_STORAGE,
  RESOURCE_LOCAL_STORAGE,
} from '@/constants/localStorageKeyConstants';
import { request } from '@/request';

import cryptoHelper from '@/utils/crypto';
import cryptoHelpers from './cryptoGraphy';
export async function AuthorizedRoutes(fullload, currentUser) {
  const authorizedRoutesFromStorage = localStorage.getItem(AUTHORIZED_ROUTES_LOCAL_STORAGE);
  const storedAuthorizedRoutes = authorizedRoutesFromStorage
    ? cryptoHelper.decrypt(authorizedRoutesFromStorage)
    : null;
  const setAuthorizedRoutes = (routes) => {
    localStorage.setItem(
      AUTHORIZED_ROUTES_LOCAL_STORAGE,
      cryptoHelper.encrypt(JSON.stringify(routes))
    );
  };

  const setResources = async () => {
    const { result: resourceResult } = await request.get({ entity: 'resources' });
    const decryptedData = await cryptoHelpers.decrypt(resourceResult);

    window.localStorage.setItem(RESOURCE_LOCAL_STORAGE, cryptoHelper.encrypt(decryptedData));
  };
  const getResources = async () => {
    if (fullload) {
      await setResources();
    }
    let resourceData = cryptoHelper.decrypt(window.localStorage.getItem(RESOURCE_LOCAL_STORAGE));
    if (!resourceData) {
      await setResources();
      resourceData = cryptoHelper.decrypt(window.localStorage.getItem(RESOURCE_LOCAL_STORAGE));
    }
    return resourceData;
  };

  const setPermissions = async () => {
    const { result: permissionResult } = await request.get({ entity: 'permissions' });
    const decryptedData = await cryptoHelpers.decrypt(permissionResult);
    window.localStorage.setItem(PERMISSION_LOCAL_STORAGE, cryptoHelper.encrypt(decryptedData));
  };

  const getPermissions = async () => {
    if (fullload) {
      await setPermissions();
    }

    let permissionData = cryptoHelper.decrypt(
      window.localStorage.getItem(PERMISSION_LOCAL_STORAGE)
    );
    if (!permissionData) {
      await setPermissions();
      permissionData = cryptoHelper.decrypt(window.localStorage.getItem(PERMISSION_LOCAL_STORAGE));
    }
    return permissionData;
  };

  const fetchRoutes = async () => {
    if (currentUser?.role) {
      const { role } = currentUser;
      const { result: roleResult } = await request.read({ entity: 'role', id: role._id });

      const resourceData = await getResources();

      // console.log('resourceData: ', resourceData);

      const permissionData = await getPermissions();
      // console.log('permissionData: ', permissionData);
      const authorizedRouteUrls = roleResult.resources
        .filter((resourceItem) =>
          resourceData.some((resource) => resource._id === resourceItem.resource)
        )
        .map((resourceItem) => {
          const matchingResource = resourceData.find(
            (resource) => resource._id === resourceItem.resource
          );
          const resourceName =
            matchingResource?.name.charAt(0).toLowerCase() + matchingResource?.name.slice(1);
          const { permissions } = resourceItem;
          let hasReadPermission = false;
          const permissionNames = permissions.map((permissionItem) => {
            const permissionDetails = permissionData.find((per) => per._id === permissionItem);
            if (resourceName !== 'dashboard') {
              if (
                permissionDetails.name === 'update' ||
                permissionDetails.name === 'read' ||
                permissionDetails.name === 'report'
              ) {
                if (resourceName === 'initiative' && permissionDetails.name === 'read') {
                  hasReadPermission = true;
                }
                return `/${resourceName}/${permissionDetails.name}/:id`;
              } else {
                return permissionDetails ? `/${resourceName}/${permissionDetails.name}` : null;
              }
            }
            return null;
          });
          if (resourceName === 'dashboard') {
            permissionNames.push(`/`);
          } else {
            if (hasReadPermission) {
              permissionNames.push(`/${resourceName}/:id`);
            }
            permissionNames.push(`/${resourceName}`);
          }
          permissionNames.push(`/profile`);
          permissionNames.push(`/logout`);

          return permissionNames.filter((item) => item !== null);
        });

      if (authorizedRouteUrls.length > 0) {
        const routes = { [roleResult.name]: authorizedRouteUrls.flat() };
        setAuthorizedRoutes(routes);
      }
    }
  };

  if (fullload) {
    await fetchRoutes();
  } else if (!fullload && !storedAuthorizedRoutes) {
    await fetchRoutes();
  }

  if (storedAuthorizedRoutes) {
    return storedAuthorizedRoutes;
  }

  return { profile: ['/profile'] };
}
